import { render, staticRenderFns } from "./trees.vue?vue&type=template&id=636df04c&scoped=true&"
import script from "./trees.vue?vue&type=script&lang=js&"
export * from "./trees.vue?vue&type=script&lang=js&"
import style0 from "./trees.vue?vue&type=style&index=0&id=636df04c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636df04c",
  null
  
)

export default component.exports